// 画像プレビューモーダル
const ModalImagePreview = {
  namespaced: true,

  state: {
    modal: false,
    path: '',
    isPanorama: false,
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getPath: state => {
      return state.path
    },
    getIsPanorama: state => {
      return state.isPanorama
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setPath(state, path) {
      state.path = path
    },
    setIsPanorama(state, panorama) {
      state.isPanorama = panorama
    },
  },
  actions: {
    show({ commit }, payload) {
      commit('setPath', payload.path)
      commit('setIsPanorama', payload.isPanorama)
      commit('setModal', true)
    },
    hide({ commit }) {
      commit('setModal', false)
      commit('setPath', '')
      commit('setIsPanorama', false)
    },
  },
}

export default ModalImagePreview
